import React from 'react';
import classNames from 'classnames';
import { Icon } from '../Icon/Icon';
import uuidv4 from '../../utils/uuidv4';
const ID = uuidv4();
const NOTIFICATIONS_GROUP_ID = `notifications-group-${ID}`;
/**
 * Bronson NotificationsGroup component.
 * Groups all related {@link Notification}.
 * @constructor
 */
export function NotificationsGroup({ ariaLabel, children, testId, ...otherProps }) {
    const groupClassName = classNames('c-notifications-group', 'js-is-ready', // Used in Bronson CSS.
    'is-stacked').trim();
    return (React.createElement("section", { id: NOTIFICATIONS_GROUP_ID, className: groupClassName, "data-testid": testId, "aria-label": ariaLabel, ...otherProps }, children));
}
/**
 * Bronson Notification component (nested).
 * @see https://bronson.vwfs.io/default/components/detail/bronson-notification.html
 */
export function Notification({ buttons = null, children, className, closeLabel = 'Close Notification', context, hideTitle = false, onCloseClick, showCloseButton = true, status, title, visible, testId, ...otherProps }) {
    const NOTIFICATION_ID = uuidv4(`notification-${ID}-`);
    const containerClassName = classNames('c-notification__container', 'js-is-ready' // Used in Bronson CSS.
    ).trim();
    const articleClassName = classNames('c-notification', {
        'c-notification--context': context,
        [`c-notification--${status}`]: status,
    }, className).trim();
    function renderButtons() {
        if (buttons) {
            return React.createElement("div", { className: "c-notification__buttons" }, buttons);
        }
        return null;
    }
    function renderCloseButton() {
        if (showCloseButton) {
            return (React.createElement("button", { "aria-label": closeLabel, className: "c-notification__close", type: "button", onClick: onCloseClick }));
        }
        return null;
    }
    function renderIfStatus() {
        return status ? React.createElement(Icon, { className: "c-notification__status-icon", viaCss: true }) : null;
    }
    function renderChildren() {
        /**
         * Render out {@link children} as content for `.c-notification__text`.
         */
        return React.createElement("div", { className: "c-notification__text" }, children);
    }
    return visible ? (React.createElement("div", { className: containerClassName, "data-testid": testId },
        React.createElement("article", { "aria-labelledby": NOTIFICATION_ID, className: articleClassName, ...otherProps },
            React.createElement("div", { className: "c-notification__outer-wrap" },
                React.createElement("div", { className: "c-notification__inner-wrap" },
                    renderIfStatus(),
                    React.createElement("div", { className: "c-notification__content" },
                        React.createElement("div", { className: `c-notification__title${hideTitle ? ' u-visually-hidden' : ''}`, id: NOTIFICATION_ID }, title),
                        renderChildren(),
                        renderButtons()),
                    renderCloseButton()))))) : null;
}
